import { render, staticRenderFns } from "./level_t.vue?vue&type=template&id=59210e28&"
import script from "./level_t.vue?vue&type=script&lang=js&"
export * from "./level_t.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports